import { useSelector } from "react-redux"
import styled from "styled-components"
import { useDispatch } from "react-redux";
import { setControlContainer, setDecodedPolylineList, setIsCenterResultContainer, setIsDurationStrict, setRouteControlContainer, setRouteResultList, setRouteTrafficResultList, updateKmData, updateSelectedRouteItem } from "../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice";
import { IoIosArrowForward, IoIosArrowBack  } from "react-icons/io";
import { GoogleMap, InfoWindow, Marker, Polyline } from "@react-google-maps/api";
import { useEffect, useState } from "react";
import decodePolyline from "../../../helper/nakliyeHesaplama/decodePolyline";

const Container = styled.div`
    width: 100%;
    height: ${({isCenterResultContainerOpen}) => isCenterResultContainerOpen ? "calc(100% - 350px)" : "100%"};
    transition: .3s;
    background-color: ${({theme}) => theme.secondaryBgColor};
    position: relative;
    

    .control-container-showed-btn{
      position: absolute;
      top: 0;
      left: 0;
      width: 50px;
      height: 40px;
      border: 1px solid #fff;
      border-radius: 0 5px 5px 0;
      background-color: ${({theme}) => theme.mainBgColor};
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 5;


      .icon{
        font-size: 1.4rem;
        transition: .3s;
        color: ${({theme}) => theme.mainTextColor} !important;
        transform: ${({ isControlContainerOpen }) => isControlContainerOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
      }
    }

    .route-control-container-showed-btn{
      position: absolute;
      top: 0;
      right: 0;
      width: 50px;
      height: 40px;
      border: 1px solid #fff;
      border-radius: 5px 0 0 5px;
      background-color: ${({theme}) => theme.mainBgColor};
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 5;


      .icon{
        font-size: 1.4rem;
        transition: .3s;
        color: ${({theme}) => theme.mainTextColor} !important;
        transform: ${({ isRouteControlContainerOpen }) => isRouteControlContainerOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
      }
    }

    .extra-result-container-showed-btn{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 40px;
      border: 1px solid #fff;
      border-top-right-radius: 5px;
      background-color: ${({theme}) => theme.mainBgColor};
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 5;


      .icon{
        font-size: 1.4rem;
        transition: .3s;
        color: ${({theme}) => theme.mainTextColor} !important;
        transform: ${({ isCenterResultContainerOpen }) => isCenterResultContainerOpen ? 'rotate(270deg)' : 'rotate(90deg)'};
      }
    }

    .map-container{
      width: 100%;
      height: 100%;

      .gm-style-iw-d{
        padding-top: 10px !important;
      }
      .gm-style-iw .gm-style-iw-c{
        padding: 15px !important;
      }

      /* //! bu X iconu */
      .gm-style-iw-chr{
        display: none;
      }

      .gm-ui-hover-effect {
        display: none !important;
      }
    }
`

const InfoWindowContainer = styled.div`

  font-variant-numeric: lining-nums;
  font-size: 12px;
  font-weight: var(--font-weight-lg);
  color: ${({theme}) => theme.mainTextColor};
  cursor: pointer;


`

const center = { lat: 39.92077, lng: 32.85411 };

const alphabetList = ["A", "B", "C", "D", "E", "F", "G","H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]

const mapOptions={
  fullscreenControl: false, // Tam ekran kontrolünü kapatır
  streetViewControl: false, // Sokak görünümü kontrolünü kapatır
  mapTypeControl: false, // Harita tipi kontrolünü kapatır
  zoomControl: false, // Zoom kontrolünü kapatır
  gestureHandling: "greedy" // ctrl olayını kapatır
};


const MapContainer = () => {

  const dispatch = useDispatch()

  const {
    isControlContainerOpen,
    isRouteControlContainerOpen,
    route,
    routeResultList,
    routeTrafficResultList,
    decodedPolylineList,
    isCenterResultContainerOpen,
    resReturnGaragesList,
    selectedRouteItem,
    resCostData
  } = useSelector(state => state.nakliyeHesaplama)

  const eu = ["341", "342", "22", "59", "39", "17"]

  //! 341 İstanbul (Anadolu)
  //! 342 İstanbul (Avrupa)
  //! 17 Çanakkale
  //! 59 Tekirdağ
  //! 39 Kırklareli
  //! 22 Edirne

  const routeCityIds = route.map(item => item.cityId)

  // if(route.find)

  useEffect(() => {

    //! rota nın oluşması en az iki konum olması gerekli
    const atLeastTwo = route.filter(item => {
      return item.lat, item.lng
    })

    //! burada en az dolu rota noktası olup olmadğığnı kontrol ediyoruz
    if(atLeastTwo.length >= 2){
      fetchRoutes()
    }
  },[route])

  const fetchRoutes = async () => {

    const formattedRoute = []

    // if(){

    // }



    route.map((currentStop, i, arr) => {

      formattedRoute.push(currentStop)

      if(i+1 !== route.length){

        const nextStop = arr[i + 1]

        
        if(eu.includes(nextStop.cityId)){
          formattedRoute.push({
              lat: 41.190612,
              lng: 29.202420
        })
      }
      }
    })

    //! ilki her zaman başlangıç olmak zorunda (index yüzünden)
    const origin = {
      location: {
        latLng: {
          latitude: parseFloat(route[0].lat),
          longitude: parseFloat(route[0].lng)
        }
      }
    }

    //! burada yapılan en son eleman boş olabileceğinden değerleri dolu olan son elemanı buluyoruz
    const lastValidPoint = route.findLast(item => {
      return item.lat && item.lng
    }) 

    const destination = {
      location: {
        latLng: {
          latitude:  parseFloat(lastValidPoint?.lat),
          longitude: parseFloat(lastValidPoint?.lng)
        }
      }
    }

    //! burada ara duraklar için ilk item olmamasına seçilen son item olmamasına ve lat ve lng lerinin boş olmamasına bakıyoruz
  const intermediates = route.filter((item, i) => {
    return i !== 0 && item.lat !== lastValidPoint.lat && item.lng !== lastValidPoint.lng && item.lat && item.lng
  }).map((item) => {
    return{
      via: true,
      location: {
        latLng: {
          latitude: parseFloat(item.lat),
          longitude: parseFloat(item.lng)
        }
      }
    }
  })


    const url = "https://routes.googleapis.com/directions/v2:computeRoutes";
    const headers = {
      "Content-Type": "application/json",
      "X-Goog-Api-Key": process.env.REACT_APP_GOOGLE_API_KEY,
      "X-Goog-FieldMask": "*",
    };


    const body = {
      origin,
      destination,
      intermediates,
      travelMode: "DRIVE",
      polylineQuality: "HIGH_QUALITY",
      routingPreference: "TRAFFIC_AWARE_OPTIMAL",
      computeAlternativeRoutes: true,
      extraComputations: "TRAFFIC_ON_POLYLINE",
      // trafficModel: "PESSIMISTIC",
      // departureTime: "2024-12-25T11:00:00Z",
      units: "METRIC",
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      });

      const data = await response.json();
      

      if (data.routes && data.routes.length > 0) {
        dispatch(setRouteResultList(data.routes))
        dispatch(updateSelectedRouteItem(data.routes[0]))
        dispatch(updateKmData(data.routes[0].localizedValues.distance.text))


        const decodedList = data.routes.map(item => {
          return decodePolyline(item.polyline.encodedPolyline)
        })
        dispatch(setDecodedPolylineList(decodedList))
        dispatch(setRouteTrafficResultList(data.routes.map(item => item.travelAdvisory.speedReadingIntervals)))
      }
    } catch (error) {
      console.error("Routes API çağrısı başarısız:", error);
    }
  };

  const getPointCenter = (path) => {
    const midIndex = Math.floor(path.length / 2);
    return path[midIndex];
  }

// Trafik durumuna göre renk belirleme fonksiyonu
const getColorForSpeed = (speed, isActive) => {

  if(speed === "NORMAL"){
    return isActive ? "#1052FF" : "#ffffff77"
  }
  else if(speed === 'SLOW'){
    return '#FFA000'
  }
  else if(speed === 'TRAFFIC_JAM'){
    return '#F44336'
  }
};


  return (
    <Container isCenterResultContainerOpen={isCenterResultContainerOpen && resCostData?.midCost} isRouteControlContainerOpen={isRouteControlContainerOpen} isControlContainerOpen={isControlContainerOpen}>
        {/* //! absolute left btn */}
        <btn className="control-container-showed-btn" onClick={() => dispatch(setControlContainer(!isControlContainerOpen))}>
          <IoIosArrowForward className="icon"/>
        </btn>

        {/* //! absolute right btn */}
        <btn className="route-control-container-showed-btn" onClick={() => dispatch(setRouteControlContainer(!isRouteControlContainerOpen))}>
          <IoIosArrowBack className="icon"/>
        </btn>

        {/* //! absolute bottom left btn */}
        {
          resReturnGaragesList.length > 0 &&
          <btn className="extra-result-container-showed-btn" onClick={() => dispatch(setIsCenterResultContainer(!isCenterResultContainerOpen))}>
            <IoIosArrowBack className="icon"/>
          </btn>
        }

          <GoogleMap mapContainerClassName="map-container" center={center} zoom={7} options={mapOptions}>

          {
            decodedPolylineList.length > 0 &&
            decodedPolylineList.map((decodedPolylineItem, i) => (

              <>
                <InfoWindow
                  position={{
                    lat: getPointCenter(decodedPolylineItem).lat,
                    lng: getPointCenter(decodedPolylineItem).lng
                  }}
                >
                  <InfoWindowContainer onClick={() => {
                    dispatch(updateSelectedRouteItem(routeResultList[i]));
                    dispatch(updateKmData(routeResultList[i].localizedValues.distance.text))
                    dispatch(setIsDurationStrict(false))
                  }}>
                    {routeResultList[i].localizedValues.duration.text} {" - "}
                    {routeResultList[i].localizedValues.distance.text}
                  </InfoWindowContainer>
                </InfoWindow>
                {
                  routeTrafficResultList[i].map((interval) => {
                  //!  Belirli aralıktaki polyline segmentini ayır
                  
                  //! burada trafic durumuna göre ayrılacak ve her biri ayrı bir polyline olarak gösterilecek
                  const segment = decodedPolylineItem.slice(
                    interval.startPolylinePointIndex,
                    interval.endPolylinePointIndex + 1
                  );

                  
                  return (
                    <>
                    <Polyline
                    path={segment}
                    options={{
                      strokeColor: getColorForSpeed(interval.speed, selectedRouteItem?.routeToken === routeResultList[i]?.routeToken),
                      strokeWeight: 4,
                      zIndex: selectedRouteItem?.routeToken === routeResultList[i]?.routeToken ? 5 : 3,
                    }}
                    onClick={() => {
                      dispatch(updateSelectedRouteItem(routeResultList[i]));
                      dispatch(updateKmData(routeResultList[i].localizedValues.distance.text))
                      dispatch(setIsDurationStrict(false))
                    }}
                    />
                    <Polyline
                      path={segment}
                      options={{
                        strokeColor: selectedRouteItem?.routeToken === routeResultList[i]?.routeToken ? "#0B11D9" : "#878beb",
                        zIndex: selectedRouteItem?.routeToken === routeResultList[i]?.routeToken ? 4 : 2,
                        strokeWeight: 8,
                      }}
                      onClick={() => {
                        dispatch(updateSelectedRouteItem(routeResultList[i]));
                        dispatch(updateKmData(routeResultList[i].localizedValues.distance.text))
                        dispatch(setIsDurationStrict(false))
                      }}
                    />
                    </>
                  )
                  })
                }
                </>
            ))
          }


          {
            route.filter((item) => item.lat && item.lng).map((item, i) => (
              <Marker
                key={i}
                position={{
                  lat: parseFloat(item.lat),
                  lng: parseFloat(item.lng)
                }}
                label={{
                  text: alphabetList[i],
                  color: "#FFFFFF",
                  fontSize: "14px",
                }}
                options={{
                  color: "#fff"
                }}
              />
            ))
          }

       </GoogleMap>

    </Container>
  )
}

export default MapContainer